/**
 * SchoolVerse sharing helpers.
 * Pass 41D: centralized, truthful sharing messages and deep-link construction.
 */

export function getShopimaxBaseUrl() {
  if (typeof window === "undefined") return "";
  return window.location.origin + window.location.pathname;
}

export function buildProductShareUrl(productId) {
  return `${getShopimaxBaseUrl()}#/product/${encodeURIComponent(productId)}`;
}

export function buildVendorShareUrl(vendorId) {
  return `${getShopimaxBaseUrl()}#/vendor/${encodeURIComponent(vendorId)}`;
}

export function buildCategoryShareUrl(categoryId) {
  return `${getShopimaxBaseUrl()}#/category/${encodeURIComponent(categoryId)}`;
}

export function buildProductShareText(product = {}) {
  const name = product.name || "this product";
  const price = product.price != null ? ` - ₦${Number(product.price).toLocaleString()}` : "";
  return `Check out ${name}${price} on SchoolVerse.`;
}

export function buildVendorShareText(vendor = {}) {
  const name = vendor.name || "this vendor";
  return `Check out ${name} on SchoolVerse.`;
}

export function buildCategoryShareText(category = {}) {
  const name = category.name || "this category";
  return `Explore ${name} on SchoolVerse.`;
}

/**
 * Native share first; otherwise copy the URL.
 * Returns: "shared" | "copied" | "failed"
 */
export async function shareShopimax({ title, text, url }) {
  try {
    if (typeof navigator !== "undefined" && navigator.share) {
      await navigator.share({ title, text, url });
      return "shared";
    }
    if (typeof navigator !== "undefined" && navigator.clipboard) {
      await navigator.clipboard.writeText(url);
      return "copied";
    }
  } catch (error) {
    if (error?.name === "AbortError") return "failed";
  }
  return "failed";
}
